// Mirrors bioplanner.shared/Constants/SwapOfferStatus.cs.
export class BPSwapOfferStatus {
}
BPSwapOfferStatus.pending = 0;
BPSwapOfferStatus.accepted = 1;
BPSwapOfferStatus.rejected = 2;
BPSwapOfferStatus.withdrawn = 3;
BPSwapOfferStatus.lapsed = 4;
export const swapOfferStatusText = (status) => {
    switch (status) {
        case BPSwapOfferStatus.pending: return "Afventer svar";
        case BPSwapOfferStatus.accepted: return "Accepteret";
        case BPSwapOfferStatus.rejected: return "Afvist";
        case BPSwapOfferStatus.withdrawn: return "Trukket tilbage";
        // The byttevagt went another way - taken by somebody else, withdrawn, or another offer
        // on it was accepted.
        case BPSwapOfferStatus.lapsed: return "Bortfaldet";
        default: return "Ukendt";
    }
};
